import { DRAFT_SOURCES } from './shared-responder-v2-core-thread.consts';
import type { ResponderThread } from './shared-responder-v2-core-thread.types';

export function isDraftClaimedBySurface(thread: ResponderThread): boolean {
  return thread.draftSource === DRAFT_SOURCES.Surface;
}

export function withoutDraftSource(thread: ResponderThread): ResponderThread {
  return { ...thread, draftSource: undefined };
}
